/** Inclusive UTC calendar dates, matching the process overview API. */
export function previousPeriod(from: string, to: string) {
  if (!from || !to) return null;
  const start = Date.parse(`${from}T00:00:00Z`);
  const end = Date.parse(`${to}T00:00:00Z`);
  if (!Number.isFinite(start) || !Number.isFinite(end) || start > end) return null;
  if (
    new Date(start).toISOString().slice(0, 10) !== from ||
    new Date(end).toISOString().slice(0, 10) !== to
  )
    return null;
  const day = 86_400_000;
  return {
    from: new Date(start - (end - start + day)).toISOString().slice(0, 10),
    to: new Date(start - day).toISOString().slice(0, 10),
    days: (end - start) / day + 1,
  };
}

export function metricDelta(current: number, previous: number, percentage = false) {
  if (percentage && previous === 0) return null;
  const difference = current - previous;
  const value = percentage ? Math.round((difference / previous) * 100) : difference;
  return `${value > 0 ? "+" : value < 0 ? "−" : ""}${Math.abs(value)}${percentage ? "%" : ""}`;
}
